const Vue = window.Vue;
const VueRouter = require('vue-router').default;

const transactionRouter = new VueRouter({
  routes: [
    {
      name: 'transaction',
      path: '/',
      component: require('./components/pages/transaction/List.vue').default
    },
    {
      name: 'transaction-statement',
      path: '/statement',
      component: require('./components/pages/transaction/Statement.vue').default
    }
  ],
})

Vue.component('transaction-app', require('./components/pages/transaction/Index.vue').default)

if ($('#transaction-app').length) { // for transaction-contract-app
  const app = new Vue({
    router: transactionRouter
  }).$mount('#transaction-app');
}